import Button, { ActionButton } from '@bugbug/core/components/Button';
import { Trans, useTranslation } from 'react-i18next';

import { Header, WarningIcon, Footer } from '~/components/modals/Modal';
import useModal from '~/hooks/useModal';
import { useSplitGroup } from '~/modules/tests/hooks/useSplitGroup/useSplitGroup';

import * as S from './GroupSplitConfirmationModal.styled';

interface GroupSplitConfirmationModalProps {
  testId: string;
  groupId: string;
  testsCount: number;
  index: number;
}

const GroupSplitConfirmationModal = ({
  testId,
  groupId,
  testsCount,
  index,
}: GroupSplitConfirmationModalProps) => {
  const modal = useModal();
  const { t } = useTranslation(undefined);
  const [splitGroup, splitRequestState] = useSplitGroup();

  const handleConfirm = async () => {
    await splitGroup({
      id: groupId,
      testId,
      atIndex: index,
    });

    modal.hide();
  };

  return (
    <div>
      <S.Content>
        <WarningIcon />
        <div>
          <Header>{t('groupSplitConfirmationModal.title', 'Are you sure?')}</Header>
          <Trans i18nKey="groupSplitConfirmationModal.description" values={{ testsCount }}>
            The action will affect <S.Warning>all {{ testsCount }} tests</S.Warning> using this
            component. Do you want to proceed?
          </Trans>
        </div>
      </S.Content>
      <Footer>
        <Button onClick={modal.hide} variant="primary" bordered>
          {t('groupSplitConfirmationModal.decline', 'No')}
        </Button>
        <ActionButton
          type="submit"
          pending={splitRequestState.isLoading}
          variant="primary"
          onClick={handleConfirm}
        >
          {t('groupSplitConfirmationModal.confirm', 'Yes')}
        </ActionButton>
      </Footer>
    </div>
  );
};

export default GroupSplitConfirmationModal;
